<template>
    <div>
        <vs-row>
            <vs-col sm="12" lg="8">
                <h4 class="p-2">Ofertas de nuevo ingreso</h4>
            </vs-col>
            <vs-col sm="12" lg="4">
                <vs-button
                    success
                    class="ml-auto"
                    flat
                    @click="activeCrear =! activeCrear"
                >
                    <i class="fas fa-plus mr-2"></i> Crear registro
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo Escolar <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <template v-if="ciclosEscolares.length" autocomplete="off">
                            <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                <vs-button
                    @click="getOferta()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <tabla-oferta :parametros="parametros" :ejecutar="ejecutar" :instituciones="instituciones" :csrf_token="csrf_token"></tabla-oferta>
        <crear v-model="activeCrear" :instituciones="instituciones" :csrf_token="csrf_token" @refreshTable="getOfertaRefresh"></crear>
    </div>
</template>


<script>
import admisiones from '../../../../api/requests/admisiones.js'
import TablaOferta from './table-ofertas.vue'
import crear from './modales/crear.vue'
export default {
    props: [ 'csrf_token' ],
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCiclo: false,
            errorFields: [],
            parametros: [],
            activeCrear: false,
            ejecutar: 0
        }
    },
    components:{
        TablaOferta,
        crear
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await admisiones.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{

            }
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.loadingCiclo = true
                const { data: response } = await admisiones.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.errorFields.length){
                const params = {
                    cicloEscolar: this.cicloEscolar,
                    institucion: this.institucion
                }
                return params
            } else {
                return null
            }
        },
        getOferta(){
            this.parametros = this.sanityForm()
            this.ejecutar += 1
        },
        getOfertaRefresh(institucion, cicloEscolar){
            this.institucion = institucion
            this.cicloEscolar = cicloEscolar
            this.parametros = {
                cicloEscolar: cicloEscolar,
                institucion: institucion
            }
            this.ejecutar += 1
        }
    },
    watch:{
        institucion(){
            this.getCicloEscolar()
        }
    }
}
</script>